(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/helpers/assets/helpers.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/helpers/assets/helpers.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }

let resolveTimeZone;
let constants;
let DrawState;
if (svs.isServer) {
  const trinidad = require('trinidad-core').core;
  resolveTimeZone = trinidad.components.require('lb-utils', 'helper-formatdate').api.resolveTimeZone;
  constants = require('../../competition-handler/common/constants.es6');
  DrawState = require('../../../sport/tipsen-shared/assets/javascripts/tipsen-shared.es6').DrawState;
} else {
  resolveTimeZone = svs.components.lbUtils.helpers.formatDate.resolveTimeZone;
  constants = svs.components.marketplaceCompetition.competitionHandler.common.constants;
  DrawState = svs.components.sport.tipsenShared.DrawState;
}
const {
  competitionStates,
  competitionBackendState
} = constants;
const {
  UPCOMING,
  FINISHED,
  REG_OPEN_DRAW_DEFINED,
  REG_CLOSED_DRAW_DEFINED,
  REG_OPEN_DRAW_OPEN,
  REG_CLOSED_DRAW_OPEN,
  REG_OPEN_DRAW_LIVE,
  REG_CLOSED_DRAW_LIVE,
  REG_OPEN_DRAW_FINALIZED,
  REG_CLOSED_DRAW_FINALIZED,
  NO_COMPETITION
} = competitionStates;
const {
  CompetitionType,
  competitionUrls
} = svs.isServer ? require('../../constants/assets/javascripts/enum.es6') : svs.components.marketplaceCompetition.constants;
const resolveCompetitionName = competition => {
  if (competition) {
    return competition.compDesc;
  }
  return 'tävling';
};
const resolveCompetitionLogo = competitionId => {
  var _svs$cmsData$data$con;
  const {
    cdn2
  } = svs.core.config.data.svsconfig;
  const image = (_svs$cmsData$data$con = svs.cmsData.data.config.competitions.find(comp => comp.competitionId === competitionId)) === null || _svs$cmsData$data$con === void 0 ? void 0 : _svs$cmsData$data$con.logo;
  try {
    return _objectSpread(_objectSpread({}, image), {}, {
      cdnUrl: "".concat(cdn2).concat(image.url)
    });
  } catch (e) {
    return null;
  }
};
const resolveCompetitionBackground = competitionId => {
  var _svs$core, _svs$cmsData;
  const {
    cdn2
  } = ((_svs$core = svs.core) === null || _svs$core === void 0 || (_svs$core = _svs$core.config) === null || _svs$core === void 0 || (_svs$core = _svs$core.data) === null || _svs$core === void 0 ? void 0 : _svs$core.svsconfig) || {};
  const image = (_svs$cmsData = svs.cmsData) === null || _svs$cmsData === void 0 || (_svs$cmsData = _svs$cmsData.data) === null || _svs$cmsData === void 0 || (_svs$cmsData = _svs$cmsData.config) === null || _svs$cmsData === void 0 || (_svs$cmsData = _svs$cmsData.competitions.find(comp => comp.competitionId === competitionId)) === null || _svs$cmsData === void 0 ? void 0 : _svs$cmsData.header;
  try {
    return _objectSpread(_objectSpread({}, image), {}, {
      cdnUrl: "".concat(cdn2).concat(image.url)
    });
  } catch (e) {
    return null;
  }
};
const resolveCompetitionUrl = compType => {
  switch (compType) {
    case CompetitionType.TipsSM:
      return competitionUrls.TIPS_SM_URL;
    case CompetitionType.TipsEM:
      return competitionUrls.TIPS_EM_URL;
    default:
      return '';
  }
};

const resolveCompetitionDrawStatus = (draw, competition) => {
  var _competition$details, _competition$details2;
  const currentTime = resolveTimeZone(new Date());
  const isBeforeStartTime = currentTime < resolveTimeZone(new Date(competition.details.startTime));
  const isBeforeRegistrationStartTime = currentTime < resolveTimeZone(new Date(competition.signupStartTime));
  const canRegister = !isBeforeRegistrationStartTime && (((draw === null || draw === void 0 ? void 0 : draw.drawNumber) || 0) < competition.details.drawNumberList[0] || ((draw === null || draw === void 0 ? void 0 : draw.drawNumber) || 0) === competition.details.drawNumberList[0] && draw.drawStateId < DrawState.Regclosed);
  const isComplete = ((_competition$details = competition.details) === null || _competition$details === void 0 ? void 0 : _competition$details.state) === competitionBackendState.COMPETITION_COMPLETE;
  const lastDrawNumber = competition.details.drawNumberList.slice(-1).pop();
  const isLastOrPastLastDrawNumber = ((_competition$details2 = competition.details) === null || _competition$details2 === void 0 ? void 0 : _competition$details2.currentDrawNumber) >= lastDrawNumber;
  const getIsCompetitionFinished = () => {
    if (isLastOrPastLastDrawNumber) {
      if (draw) {
        return draw.drawStateId >= DrawState.Finalized;
      }
      return true;
    }
    return false;
  };
  if (isComplete || getIsCompetitionFinished()) {
    return FINISHED;
  } else if (isBeforeStartTime && isBeforeRegistrationStartTime) {
    return UPCOMING;
  } else if (!canRegister) {
    if (draw.drawStateId >= DrawState.Finalized) {
      return REG_CLOSED_DRAW_FINALIZED;
    } else if (draw.drawStateId >= DrawState.Regclosed) {
      return REG_CLOSED_DRAW_LIVE;
    } else if (draw.drawStateId >= DrawState.Opened) {
      return REG_CLOSED_DRAW_OPEN;
    } else if (draw.drawStateId >= DrawState.Defined) {
      return REG_CLOSED_DRAW_DEFINED;
    }
  } else if (canRegister) {
    if (!draw) {
      return REG_OPEN_DRAW_DEFINED;
    } else if (draw.drawStateId >= DrawState.Finalized) {
      return REG_OPEN_DRAW_FINALIZED;
    } else if (draw.drawStateId >= DrawState.Regclosed) {
      return REG_OPEN_DRAW_LIVE;
    } else if (draw.drawStateId >= DrawState.Opened) {
      return REG_OPEN_DRAW_OPEN;
    } else if (draw.drawStateId >= DrawState.Defined) {
      return REG_OPEN_DRAW_DEFINED;
    }
    return REG_OPEN_DRAW_OPEN;
  }
  return NO_COMPETITION; 
};

const toExport = {
  resolveCompetitionBackground,
  resolveCompetitionLogo,
  resolveCompetitionName,
  resolveCompetitionUrl,
  resolveCompetitionDrawStatus
};
if (svs.isServer) {
  module.exports = toExport;
} else {
  setGlobal('svs.components.marketplaceCompetition.helpers', toExport);
}

 })(window);